export * from './delete-vermerk.component';
export * from './delete-vermerk.component.module';